import { Chip} from "@mui/material"
import { Stack } from "@mui/system"
import React from "react"
import { useParams } from "react-router";
import {useCaseFindQuery } from "../../../../../services/scheduleService/schedule-api";
import { useVerificationFindQuery } from "../../../../../services/verifyService/verify-api";
import {Phone, PhoneIphone, Email} from '@mui/icons-material'

function PatientContact(){
    const {id} = useParams()
    const {data} = useCaseFindQuery(id!);
    const verification = useVerificationFindQuery(id!);

    const isPreQuote = verification.data?.verifyAttributes?.isPreQuote;
    const preQuotePhone = isPreQuote ? verification.data?.preQuoteAttributes?.phoneNumber : undefined;

    const homePhone = data?.homePhone || preQuotePhone || 'Unknown';
    const mobilePhone = data?.mobilePhone || preQuotePhone || 'Unknown';
    const email = (data?.email !=='' && data?.email !== null) ? data?.email : 'Unknown';

    return <React.Fragment>
        <Stack direction='row' justifyContent='space-between' marginRight='10px' marginLeft='10px'>
            <Chip icon={<Phone/>} variant='outlined' color='primary' label={homePhone} />
            <Chip icon={<PhoneIphone/>} variant='outlined' color='primary' label={mobilePhone}/>
            <Chip icon={<Email/>} variant='outlined' color='primary' label={email}/>
        </Stack>
    </React.Fragment>
}

export {PatientContact}